import { FC } from "react"
import { useFormikContext } from "formik"
import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import ColorPicker from "../color-picker"

interface Props {
  integration?: Integration
}

const Colors: FC<Props> = ({ integration }) => {
  const { app_settings } = useIntegrationSettingsForm(integration)
  const formik = useFormikContext<Integration>()

  const accentColor = integration
    ? app_settings?.settings?.accent_color ?? ""
    : formik.values.app_settings?.settings?.accent_color ?? ""

  const secondaryColor = integration
    ? app_settings?.settings?.secondary_accent_color ?? ""
    : formik.values.app_settings?.settings?.secondary_accent_color ?? ""

  return (
    <div className="grid gap-y-6 gap-x-4 grid-cols-12 pt-6">
      <div className="col-span-6">
        <ColorPicker
          name="accent_color"
          label="Primary Color"
          labelClassName="text-neutral-400 text-xs uppercase"
          value={accentColor}
          integration={integration}
        />
      </div>
      <div className="col-span-6">
        <ColorPicker
          name="secondary_accent_color"
          label="Secondary Color"
          labelClassName="text-neutral-400 text-xs uppercase"
          value={secondaryColor}
          integration={integration}
        />
      </div>
    </div>
  )
}

export default Colors
